import { InjectionToken } from '@angular/core'
import { AuthConfig } from 'angular-oauth2-oidc'

export interface OidcResourceServerConfig {
  allowedUrls: string[]
  sendAccessToken: boolean
}

export interface OidcAuthConfiguration {
  config: AuthConfig
  resourceServer: OidcResourceServerConfig
}

export interface CookieAuthConfiguration {
  meUrl: string
  loginUrl: string
  logoutUrl: string
}

// --- Runtime configuration loaded from /api/config (OIDC builds only) ---

export interface RuntimeOidcConfig {
  issuer: string
  clientId: string
  scope?: string
  audience?: string
  logoutUrl?: string
  connection?: string
  display?: string
  allowedUrls?: string[]
}

export interface AppRuntimeConfig {
  url: string
  auth: RuntimeOidcConfig
}

export const APP_CONFIG = new InjectionToken<AppRuntimeConfig>('APP_CONFIG')

export const toOidcAuthConfiguration = (oidc: RuntimeOidcConfig): OidcAuthConfiguration => ({
  config: {
    issuer: oidc.issuer,
    redirectUri: window.location.origin,
    clientId: oidc.clientId,
    customQueryParams: {
      ...(oidc.connection && { connection: oidc.connection }),
      ...(oidc.display && { display: oidc.display }),
      ...(oidc.audience && { audience: oidc.audience }),
    },
    responseType: 'code',
    scope: oidc.scope ?? 'openid profile email offline_access',
    logoutUrl: oidc.logoutUrl ?? '',
  },
  resourceServer: {
    allowedUrls: oidc.allowedUrls ?? ['/api'],
    sendAccessToken: true,
  },
})
